import { type ICallEvent } from '@/types/ICallEvent';
import { type ICallHistoryEvent } from '@/types/ICallHistoryEvent';
import { type ICallPayload, type TCallSource } from '@/types/ICallPayload';
import { formatPhoneNumber } from './formatPhoneNumber';

const SECONDS_TO_MS = 1000;

/**
 * Нормализует живое или историческое событие звонка в единый payload для
 * тоста и модального окна.
 *
 * Телефон приводится к «только цифрам» — он же ключ дедупа и гашения карточки.
 * `datetime` приходит в СЕКУНДАХ, переводим в миллисекунды; если поля нет
 * (форма исторического топика не подтверждена) — берём время получения.
 *
 * @param event - событие из топика `admin_calls` или `admin_calls_history`
 * @param source - источник карточки: входящий или пропущенный звонок
 * @returns нормализованные данные звонка
 */
export const toCallPayload = (
  event: ICallEvent | ICallHistoryEvent,
  source: TCallSource
): ICallPayload => ({
  phone: formatPhoneNumber(event.data.incoming_phone),
  account: event.data.user,
  occurredAt:
    typeof event.datetime === 'number'
      ? event.datetime * SECONDS_TO_MS
      : Date.now(),
  source
});
